import type { NotificationProvider } from "@refinedev/core";

export type Toast = { key: string | number; message: string; description?: any; type: string };

let pushFn: ((t: Toast) => void) | null = null;

export function registerToastHandler(fn: ((t: Toast) => void) | null) {
  pushFn = fn;
}

export function isToastLink(description: any): boolean {
  if (typeof description !== "string") return false;
  const trimmed = description.trim();
  return trimmed.startsWith("/") || trimmed.startsWith("http://") || trimmed.startsWith("https://");
}

export const notificationProvider: NotificationProvider = {
  open: ({ message, description, type, key }: any) => {
    pushFn?.({ key: key ?? Date.now(), message, description, type: type ?? "info" });
  },
  close: () => {},
};
